<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .activity-tab {
    height: 100%;
    overflow: auto;
    padding-top: utils.in_rem(16px);
    position: relative;
  }
</style>

<script>
  import { hasConversationsLicense } from "@sourcewhale/core";
  import {
    teamHasDiallerStore,
    userStore,
  } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  // Components
  import TabPanel from "@sourcewhale/shared/svelte-design-system/components/molecules/TabPanel.svelte";
  // Components - tabs
  import OpportunityInfoCard from "../components/OpportunityInfoCard.svelte";
  import Calls from "./Calls.svelte";
  import ContactActivity from "./ContactActivity.svelte";
  import EmailEngagement from "./EmailEngagement.svelte";

  const tabItems = $derived(
    [
      {
        label: "All Activity",
        slot: "contactActivityTab",
        snippet: contactActivitySnippet,
      },
      {
        label: "Calls",
        slot: "callsTab",
        snippet: callsSnippet,
        show: () => $teamHasDiallerStore && hasConversationsLicense($userStore),
      },
      {
        label: "Emails",
        slot: "emailEngagementTab",
        snippet: emailEngagementSnippet,
      },
    ].filter((item) => !item.show || item.show())
  );
</script>

{#snippet contactActivitySnippet()}
  <ContactActivity />
{/snippet}

{#snippet callsSnippet()}
  <Calls />
{/snippet}

{#snippet emailEngagementSnippet()}
  <EmailEngagement />
{/snippet}

<OpportunityInfoCard />
<div class="activity-tab">
  <TabPanel type="secondary-pill" size="small" {tabItems} />
</div>
